import styled from 'styled-components';

export const FileUploadWrapperStyled = styled.div`
  padding: 4rem 0 0;
`;
